import { render, staticRenderFns } from "./UnitOfMeasureSelector.vue?vue&type=template&id=01c60377"
import script from "./UnitOfMeasureSelector.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasureSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports